import React, { useContext } from 'react';
import Image1 from '../assets/Image1.svg';
import { ChatbotContext } from '../Context/ChatbotContext';

const Hero = () => {
  const { toggleChat } = useContext(ChatbotContext); 
  return (
    <section className="hero-section " id="inicio">
      
     
      <div className="hero-content">


      <div className='hero-texts'>
      <div className="purple-title ">
        <h1 className=" ">Bussiness Support</h1>
      </div>
      <div className='space-y-3 mb:space-y-2 tabs:space-y-2'>
        <h1 className=" hero-h1 ">MENTOR-IA: </h1>
        <h2 className="hero-h4 ">Transforma Documentos En Conocimiento Útil</h2>
        <h2 className="hero-h3">Bienvenido a una nueva era de optimización y eficiencia  </h2>
      </div>
    
        <p className="hero-p">
        La Solución de IA compatible con Múltiples plataformas que Centraliza, Optimiza y Personaliza tu Conocimiento Empresarial 
        </p>


      </div>


        <button className="btn-secondary  " onClick={toggleChat}>Comienza tu demo</button>
      </div>
      
  
      <div className="image-container">
        <img src={Image1} alt="Gráfico" className=" animate-float" />
      </div>

    </section>
  );
};

export default Hero;
